module.exports = __webpack_public_path__ + "img/dustland_slide_2.718f1662.jpg";